/**
 * @see mockMd/union_city_war_remind.md
 */
import {UnionCityWarRemindStatus, type UnionCityWarRemindData} from '../types'

export const UnionCityWarRemindMock: UnionCityWarRemindData = {
  status: UnionCityWarRemindStatus.Success,
  remind_cnt: 8,
  err_msg: '',
}
